import { CountryCode } from '@dayetopia/types';
import { SpecialistSectionId, getSpecialists, getSpecialistsForProductPage } from '@components/dashboard/data/Specialists';
import { BadgeType, DigitalServiceType, ProductCode } from '@contracts';
import { getListOfIncludesForProduct, getProductSubtitle, getProductTitle } from '@data/products';

export function getShoppingAddonIsHighlighted(productCode: ProductCode): boolean {
  switch (productCode) {
    case ProductCode.ConsultationSexualHealth:
      return true;
    default:
      return false;
  }
}

export function getShoppingAddonBadgeType(productCode: ProductCode): BadgeType | undefined {
  switch (productCode) {
    case ProductCode.ConsultationSexualHealth:
      return 'recommended';
    default:
      return undefined;
  }
}

export function getShoppingAddonBadgeText(productCode: ProductCode): string {
  switch (productCode) {
    case ProductCode.ConsultationSexualHealth:
      return 'components.recommended';
    default:
      return '';
  }
}

export function getShoppingAddonTitle(productCode: ProductCode): string {
  switch (productCode) {
    case ProductCode.ConsultationSexualHealth: {
      return 'components.expert-nurse-consultation';
    }
    default:
      return getProductTitle(productCode);
  }
}

export function getShoppingAddonSubtitle(productCode: ProductCode): string[] {
  switch (productCode) {
    case ProductCode.ConsultationSexualHealth:
      return ['components.expert-nurse-consultation-desc'];
    default:
      break;
  }

  const productIncludes = getListOfIncludesForProduct(productCode);
  const subtitle = getProductSubtitle(productCode);
  const productSubtitleData = [];

  if (productIncludes.length > 0) {
    productSubtitleData.push(...productIncludes);
  }

  if (subtitle) {
    productSubtitleData.push(subtitle);
  }

  return productSubtitleData;
}

export function getShoppingAddonPriceSuffix(productCode: ProductCode, country: CountryCode): string {
  switch (productCode) {
    case ProductCode.ConsultationSexualHealth: {
      const specialistsData = getSpecialists({ type: DigitalServiceType.VMS, country });
      const specialistsSection = specialistsData.find((section) => section.id === SpecialistSectionId.SexualReproductive);
      const sectionTimeWithNoSpaces = specialistsSection?.time?.replace(/\s/g, '');
      return sectionTimeWithNoSpaces ? `/${sectionTimeWithNoSpaces}` : '';
    }
    default:
      return '';
  }
}

export function getShoppingAddonIcons(productCode: ProductCode, country: CountryCode): string[] {
  switch (productCode) {
    case ProductCode.ConsultationSexualHealth: {
      const specialistsSection = getSpecialistsForProductPage(DigitalServiceType.VMS, country, SpecialistSectionId.SexualReproductive);
      const icons: string[] = [];

      if (specialistsSection) {
        specialistsSection.forEach((person) => {
          icons.push(person.picture);
        });
      }

      return icons;
    }
    default:
      return [];
  }
}
